/**
 * One box over dancers, families, classes and staff (D-325).
 *
 * "Find a dancer" was a rail item and should never have been one: every other
 * destination is a *place* and that one was a *question*.
 */
export type SearchHit = {
  /** `"Dancer"`, `"Class"`, `"Teacher"`, `"Family"`. */
  kind: string
  id: string
  title: string
  detail: string | null

  /**
   * Where this reader can go — empty when there is nowhere she may open.
   *
   * The server decides, because it knows what she holds. A hit linking
   * somewhere she is refused is the fault the bell already fixed once (D-324):
   * better no link than a link that says no.
   */
  href: string
}

export type SearchResults = {
  hits: SearchHit[]

  /**
   * The answer is scoped to her, not to the studio.
   *
   * **Only the server can say this**, and without it an empty list is
   * ambiguous: "no dancer by that name" and "not one of yours" are different
   * facts and a screen cannot tell them apart (D-209).
   */
  narrowed: boolean
}

/** Below this, one letter matches most of the studio — the server agrees. */
export const SHORTEST_TERM = 2

export async function search(q: string): Promise<SearchResults> {
  const res = await fetch(`/api/search?q=${encodeURIComponent(q)}`)
  if (!res.ok) throw new Error(`Could not search just now (${res.status})`)
  return res.json()
}
